// src/dataset/blog-posts.js

import imgGrowMaximize from "../images/blog/TSD_Header_1_featured.jpg";
import imgMarketingPlan from "../images/blog/TSD_Wrapping_Featured.jpg";
import imgRecession from "../images/blog/TSD_Blog_Overview_Recession.jpg";
import imgHolidayPart2 from "../images/blog/TSD_Blog_Overview_Holiday_Shopping_Season_2.jpg";
import imgHolidayPart1 from "../images/blog/TSD_Blog_Overview_Holiday_Shopping_Season.jpg";
import imgHello from "../images/blog/TSD_Blog_Intro_Content_Overview.jpg";
import imgFranchise from "../images/blog/TSD_Header_2_feautured.jpg";
import imgAssociationMarketing from "../images/blog/TSD_Header_3_featured.jpg";
import imgTradeMarketing from "../images/blog/TSD_Header_4_Featured.jpg";

const blogPosts = [
  {
    title: "Trade Marketing: Your Partner in Retail Success",
    path: "/marketing-minutes/trade-marketing",
    featuredImage: imgTradeMarketing,
    excerpt:
      "In today’s competitive retail landscape, getting your product onto store shelves is just the beginning. Successful brands need thoughtful trade marketing strategies that drive sales, build retail partnerships, and create lasting market presence.",
    categories: ["Insights"],
    date: "2025-05-22",
  },
  {
    title: "Association Marketing: Building Value Through Brand Identity",
    path: "/marketing-minutes/association-marketing",
    featuredImage: imgAssociationMarketing,
    excerpt:
      "At The Simple Department, we’ve learned that associations with powerful brand identities deliver greater member benefits, attract new participants, and create lasting impact in their industries.",
    categories: ["Insights"],
    date: "2025-05-22",
  },
  {
    title: "Franchise Marketing: Balancing Brand Consistency and Local Relevance",
    path: "/marketing-minutes/franchise-marketing",
    featuredImage: imgFranchise,
    excerpt:
      "At The Simple Department, we’ve spent years learning how to navigate this balance, supporting both franchisors and franchisees in achieving their growth objectives.",
    categories: ["Insights"],
    date: "2025-05-21",
  },
  {
    title: "Grow, Maximize, Retain: A [Industry] Growth Framework",
    path: "/marketing-minutes/grow-maximize-retain",
    featuredImage: imgGrowMaximize,
    excerpt:
      "At The Simple Department, we’ve observed that successful [INDUSTRY] businesses focus on three critical growth drivers: attracting more clients, maximizing the value of each relationship, and extending client retention.",
    categories: ["Insights"],
    date: "2025-05-20",
  },
  {
    title: "Your Simple Guide to a 2023 Marketing Plan",
    path: "/marketing-minutes/2023-marketing-plan",
    featuredImage: imgMarketingPlan,
    excerpt:
      "As we head into 2023, it's time to re-evaluate your marketing strategy. In this post, we’ll walk you through some simple yet powerful steps to build an effective marketing plan for the new year.",
    categories: ["The Simple Department"],
    date: "2022-12-30",
  },
  {
    title: "Tips to Ride Out the Recession as a Small Business",
    path: "/marketing-minutes/recession-small-biz",
    featuredImage: imgRecession,
    excerpt:
      "If you’re a small business owner, you might panic at the first whiff of the word “recession.” When faced with economic uncertainty, it’s all too easy to spiral into doom and gloom...",
    categories: ["The Simple Department"],
    date: "2022-11-17",
  },
  {
    title: "Marketing Tips for the Holiday Shopping Season Part 2",
    path: "/marketing-minutes/holiday-shopping-season-marketing-part-2",
    featuredImage: imgHolidayPart2,
    excerpt:
      "The very best time you can host giveaways through your social account is right before the busy shopping time hits – that means within the next 3-4 weeks...",
    categories: ["The Simple Department"],
    date: "2022-10-21",
  },
  {
    title: "Marketing Tips for the Holiday Shopping Season Part 1",
    path: "/marketing-minutes/holiday-shopping-season-marketing-part-1",
    featuredImage: imgHolidayPart1,
    excerpt:
      "The holiday shopping season is officially here! Ensure your campaigns go off with a hitch and the revenue rolls in this quarter with these helpful tips from our team.",
    categories: ["The Simple Department"],
    date: "2022-10-14",
  },
  {
    title: "Say Hello to Simple",
    path: "/marketing-minutes/hello",
    featuredImage: imgHello,
    excerpt:
      "If you’re here, you may have already seen our website or our Instagram. Or maybe you just wandered in off Google. Regardless, hello! We’re glad you’re here.",
    categories: ["The Simple Department"],
    date: "2022-09-10",
  },
];

export default blogPosts;
